// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class CouponEnrollmentCommunicationTypeUpdateProgramIdCommunicationTypeUpdateResponse {
    static getAttributeTypeMap() {
        return CouponEnrollmentCommunicationTypeUpdateProgramIdCommunicationTypeUpdateResponse.attributeTypeMap;
    }
}
CouponEnrollmentCommunicationTypeUpdateProgramIdCommunicationTypeUpdateResponse.discriminator = undefined;
CouponEnrollmentCommunicationTypeUpdateProgramIdCommunicationTypeUpdateResponse.attributeTypeMap = [
    {
        "name": "success",
        "baseName": "success",
        "type": "boolean"
    },
    {
        "name": "data",
        "baseName": "data",
        "type": "EnrollmentResponseModel"
    },
    {
        "name": "messages",
        "baseName": "messages",
        "type": "Array<string>"
    }
];
//# sourceMappingURL=couponEnrollmentCommunicationTypeUpdateProgramIdCommunicationTypeUpdateResponse.js.map